@if (displayLoading) {
  <app-loading-page [message]='message'></app-loading-page>
} 
@else {
  <div class="teams-page">
    <div class="header-button-combo">
      <div>
        <h2>Team Members</h2>
      </div>
      <div>
        @if (canEditTeam) {
          <button kendoButton class="btn-add" (click)="openAddContactPopup()">Add New User</button>
          <button kendoButton look="outline" class="btn-save" (click)="save()" [disabled]="!isDirty">Save</button>  
        }
      </div>
    </div>
    <div class="grid-wrapper grid-md">
      <kendo-grid 
        [data]="teamMembers"
        [scrollable]="'scrollable'"
        [resizable]="true"
      >
        <kendo-grid-column field="Contact" title="Name">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.Contact }}
            @if (dataItem.ContactID === contact.ID) {
              <span class="current-user-icon">⭐</span>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Email" title="Email"></kendo-grid-column>
        <kendo-grid-column title="Role">
          <ng-template kendoGridCellTemplate let-dataItem>
            @if(canEditRole(dataItem)) {
              <kendo-dropdownlist 
                [data]="possibleContactRoles" 
                textField="Name" 
                valueField="ID"
                [valuePrimitive]="true"
                [value]="dataItem.ContactRoleID"
                (valueChange)="onContactRoleChange(dataItem, $event)"
              ></kendo-dropdownlist>
            }
            @else {
              {{ dataItem.ContactRole }}
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Actions" [width]="175">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button *ngIf="canRemoveContact(dataItem)" kendoButton class="btn-delete" (click)="openRemoveContactPopup(dataItem)">Remove</button>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>  
    </div>
    <!-- Add User Popup -->
    @if (showAddUserPopup) {
      <kendo-dialog (close)="closeAddContactPopup()">
        <kendo-dialog-titlebar>
          Add New User
        </kendo-dialog-titlebar>
        <div class="dialog-content">
          @if (newUserDialogPage === 1) {
            <!-- Page 1: Basic Info & Subscription Selection -->
            <div class="input-wrapper">
              <input kendoTextBox [(ngModel)]="newUserFirstName" placeholder="First Name" />
            </div>
            <div class="input-wrapper">
              <input kendoTextBox [(ngModel)]="newUserLastName" placeholder="Last Name" />
            </div>
            <div class="input-wrapper">
              <input kendoTextBox [(ngModel)]="newUserEmail" placeholder="Email" />
            </div>
            <div class="input-wrapper">
              <kendo-dropdownlist
                [data]="allContactRoles"
                textField="Name"
                valueField="ID"
                [(ngModel)]="newUserRole">
              </kendo-dropdownlist>
            </div>
            <div class="input-wrapper">
              <p>Select at least one subscription to add the new member to:</p>
              @for (sub of availableSubscriptions; track sub) {
                <div class="subscription-option">
                  <p>
                    <kendo-checkbox [id]="sub.Subscription.ID"
                    [disabled]="sub.IsMaxed"
                    [checked]="newUserSubscriptions.includes(sub.Subscription.ID)"
                    (change)="onSubscriptionChange($event, sub.Subscription.ID)"></kendo-checkbox>
                    <kendo-label
                      class="k-checkbox-label"
                      [attr.for]="sub.Subscription.ID"
                    >
                    {{ sub.Subscription.Label || 'No Label' }}
                  </kendo-label>
                    @if (sub.IsMaxed) {
                      <div class="subscription-warning">
                        <span class="warning-text">Your current usage exceeds this plan's limits</span>
                        <span class="more-info" title="This subscription has reached its maximum allowed users.">ℹ️</span>
                      </div>
                    }
                </p>
                </div>
              }
            </div>
            <div class="btn-group">
              <button 
                kendoButton (click)="newUserDialogPage = 2"
                [disabled]="newUserSubscriptions.length === 0 || !isValidEmail(newUserEmail)">
                Next
              </button>
              <button kendoButton look="outline" (click)="closeAddContactPopup()">Cancel</button>
            </div>
          } @else if (newUserDialogPage === 2) {
            <!-- Page 2: Cost Breakdown with Preview Navigation -->
            <h4>Additional Monthly Costs</h4>
            <div class="preview-navigation-wrapper">
              <div class="preview-navigation" *ngIf="newUserSubscriptions.length > 1">
                <button class="nav-button" (click)="prevPreview()" [disabled]="currentPreviewIndex === 0">
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
              </div>
              <div class="preview-navigation" *ngIf="newUserSubscriptions.length > 1">
                <button class="nav-button" (click)="nextPreview()" [disabled]="currentPreviewIndex === newUserSubscriptions.length - 1">
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="table-wrapper">
              <ng-container *ngFor="let subID of newUserSubscriptions; let i = index">
                <div [hidden]="currentPreviewIndex !== i">
                  <app-subscription-update-preview 
                    [subscription]="GetSubscription(subID)"
                    [options]="getPreviewOptions(subID)"
                    (previewLoaded)="onPreviewLoaded($event, i)">
                  </app-subscription-update-preview>
                </div>
              </ng-container>
            </div>
            <div class="btn-group">
              <button kendoButton (click)="addContact()"
                [disabled]="newUserSubscriptions.length > 1 && !areAllPreviewsLoaded()">
                Confirm
              </button>
              <button kendoButton look="outline" (click)="newUserDialogPage = 1">Back</button>
            </div>
          }
        </div>
      </kendo-dialog>
    }

    <!-- Remove User Popup -->
    @if (showRemoveUserPopup) {
      <kendo-dialog (close)="closeRemoveContactPopup()">
        <kendo-dialog-titlebar>
          Remove User
        </kendo-dialog-titlebar>
        <div>
          <p>Are you sure you want to remove {{ userToRemove?.email }} from your organization?</p>
        </div>
        <div class="btn-group">
          <button kendoButton (click)="removeContact()">Continue</button>
          <button kendoButton look="outline" (click)="closeRemoveContactPopup()">Cancel</button>
        </div>
      </kendo-dialog>
    }
  </div>
}